import { AnyAction } from "redux"
import { cloneDeep } from 'lodash';
import { FETCH_UNITS, FILTER_UNITS, RESET, UPDATE_SELECTED_UNIT_MEDIC } from "../actions/unit";
import Unit from "../../models/core/unit/Unit";

interface ILogin{
    units: Unit[] | null;
    unitSelectedAppointments: any | null;
}

const initialState: ILogin = {
    units: [],
    unitSelectedAppointments: null
}

export const UnitReducer = (state = initialState, action: AnyAction) =>{
    switch(action.type){
        case RESET:{
            return {
                ...cloneDeep(initialState)
            }
        }
        case FETCH_UNITS:{
            
            return{
                ...cloneDeep(state),
                units: action.units
            }
        }
        case FILTER_UNITS:{
            return{
                ...cloneDeep(state),
                units: action.filteredUnits
            }
        }
        case UPDATE_SELECTED_UNIT_MEDIC:{
            return {
                ...cloneDeep(state),
                unitSelectedAppointments: action.unitSelectedAppointments
            }
        }
        default:{
            return state 
        }
    }
}